<div class="filter-header">
	<span class="bento-select filter-span">
		<select aria-label="Status" #statusFilter class="status-filter" (change)="statusFilterChanged($event.target.value)">
				<option *ngFor="let status of statusList" value="{{status.key}}" attr.data-qe-id="client-dashboard-task-widget-filter-{{status.name}}">
					{{status.value}}
				</option>
		</select>
		<div class="btn select-filter-button">
			<span class="bento-icon-caret-down"></span>
		</div>
		<div class="bento-select-overlay"></div>
	</span>
	<i class="bento-icon-search search-icon"></i>
	<input data-qe-id="client-dashboard-projects-tasks-searchbox" #searchInput class="search-input ng-bento form-control" type="text" (input)="searchFilterChanged($event.target.value)" placeholder="{{'bm.header.helpMenu.searchLabel' | translate}}">
</div>
<div class="ng-bento outer-container client-task-widget-container" [bentoBusyLoader]="showBusyLoader">
	<div class="repeating-item" *ngFor="let taskGroup of filteredTaskGroups">
		<div class="grid-container" [bentoBusyLoader]="taskGroup.showBusyLoader">
			<div class="taskLabel">
				<span>{{taskGroup.label}}</span>
			</div>
			<div class="editButton">
				<button data-qe-id="client-dashboard-task-widget-edit-button"
				aria-label="Edit Button {{taskGroup.label}} {{taskGroup.subject}}" class="edit-button btn-link" *ngIf="taskGroup.canEdit" (click)="editTask(taskGroup)">
					<i class="bento-icon-edit edit-button-icon"></i>
				</button>
			</div>
			<div #subjectRef class="subject" (mouseover)="checkEllipse(subjectRef, taskGroup)" ngbTooltip="{{taskGroup.showTooltip ? taskGroup.subject : null}}">
				<span class="subject-text">{{taskGroup.subject}}</span>
			</div>
			<div class="dueDateLabel">
				<span *ngIf="showDueDate(taskGroup)" class="info-type-label" translate="onvio.clientTaskWidget.label.dueDate"></span>
			</div>
			<div class="dueDate">
				<span *ngIf="showDueDate(taskGroup)">{{taskGroup.dueDate}}</span>
			</div>
			<div class="pastDue">
				<span class="label label-issue-high" translate="Bluemoon.Practice.Widget.PriorInvoices.Overdue" *ngIf="taskGroup.pastDue && showDueDate(taskGroup)"></span>
			</div>
			<div class="recipientLabel">
				<span class="info-type-label" translate="onvio.clientTaskWidget.label.recipient"></span>
			</div>
			<div class="recipientName" style="max-width: {{getMaxWidth()}}">
				<div #recipientRef class="recipient-name-string" *ngFor="let contact of taskGroup.assignedContacts" (mouseover)="checkEllipse(recipientRef, contact)" ngbTooltip="{{contact.showTooltip ? contact.name : null}}">
					{{contact.name}}
				</div>
			</div>
			<div class="viewAs" *ngIf="showViewAs">
				<div *ngFor="let contact of taskGroup.assignedContacts">
					<div ngbTooltip="{{!contact.clientCenterEnabled ? ('onvio.clientTaskWidget.viewAs.notEnabled' | translate) : null}}">
						<button translate="onvio.clientTaskWidget.viewAs" data-qe-id="client-dashboard-task-widget-view-as-link"
							class="view-as-link btn-link" (click)="viewClientCenterAs(contact, taskGroup.id)" [disabled]="!contact.clientCenterEnabled"></button>
					</div>
				</div>
			</div>
			<div class="statusLabel">
				<span class="info-type-label" translate="onvio.clientTaskWidget.label.status"></span>
			</div>
			<div class="status">
				<span>{{taskGroup.statusLabel}}</span>
				<ng-template #tipContent>{{taskGroup.esignInfo || (('Bluemoon.DMS.Requests.Template.LoadingLabel' | translate) + '...')}}</ng-template>
				<i *ngIf="showEsignInfoIcon(taskGroup)" class="esign-info-icon bento-icon-info" (mouseover)="getCanceledEsignInfo(taskGroup)" [ngbTooltip]="tipContent"></i>
			</div>
		</div>
	</div>
</div>
